import React, { useEffect, useState } from 'react'
import { FULL_LOGO_2, GENERATE_CODE, INFINITE, LANDINGIMG, MAIN_PROJECT, MAIN_PROJECT_2, USER_LOGO } from '../assets'
import './index.scss';
import { Accordion, AccordionBody, AccordionHeader, AccordionItem, Button } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { getProfileAPI } from '../redux/auth/slice';
import { useDispatch } from 'react-redux';

const LandingPage = ({ getProfileData }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [isNavOpen, setISNavOpen] = useState(false);
    const [open, setOpen] = useState('0');
    const toggle = (id) => {
        if (open === id) {
            setOpen();
        } else {
            setOpen(id);
        }
    };

    useEffect(() => {
        dispatch(getProfileAPI());
    }, [])


    return (
        <div>
            <div className="topbar_container">
                <div className="topbar_inner">
                    <div className="wordmark_wordmark">
                        <img src={FULL_LOGO_2} width={200} />
                    </div>
                    <div className="topbar-menu_menu">
                        <div aria-haspopup="menu" tabindex="0" aria-expanded="false" id="«R55jddbH1»" className="topbar-menu_button topbar-menu_active" onClick={() => navigate("/")}>Home</div>
                        <div aria-haspopup="menu" tabindex="0" aria-expanded="false" id="«R95jddbH1»" className="topbar-menu_button" onClick={() => navigate("/resources")}>Resources</div>
                    </div>
                    {localStorage?.getItem("token") ? <>

                        <div className='d-flex gap-2 cursor-pointer'>

                            <img src={USER_LOGO} height={36} />
                            <div className="topbar_rightSection"><a className="menu-button_button">{getProfileData?.name || "Devglu"}</a>
                                {/* <a className="menu-button_button menu-button_primary" onClick={() => navigate("/signup")}>Sign up</a> */}
                            </div>
                        </div>
                    </> : <>
                        <div className="topbar_rightSection"><a className="menu-button_button" onClick={() => navigate("/login")}>Login</a>
                            {/* <a className="menu-button_button menu-button_primary" onClick={() => navigate("/signup")}>Sign up</a> */}
                        </div>

                    </>}

                </div>
            </div>

            <div className="middle mt-5 d-flex justify-content-between gap-2 column-direction w-100" style={{ minWidth: window.innerWidth }}>
                <div className="matter width">
                    <span className="ready">ARE YOU READY TO ....</span>
                    <h1 className="journey">Backend development – Smarter, Faster, Better</h1>
                    <span className="devglu-produ">
                        <span className="text-style-1">DEVGLU.AI</span><span className="text-style-2"> – </span> <span className="text-style-3">Design your backend architecture with intuitive No-Code flow
                            based node diagrams. Accelerate development with AI and
                            industry-standard code base.
                        </span>
                    </span>


                    <div className="d-flex mt-4">
                        <Button className="explore-btn d-flex" color='primary' onClick={() => navigate(`/signup`)} >EXPLORE</Button>

                    </div>
                </div>
                <div className="width my-auto mx-auto">
                    <img src={LANDINGIMG} width="500px" className="img1" alt="page1" />
                </div>
            </div>


            <div style={{ marginTop: "150px" }} className="mx-auto max-w-[--page-width] px-5 content_content__zhwUl">
                <div className='d-flex justify-content-between'>
                    <div className='d-flex gap-3 flex-column'>
                        <div className="content_contentMain__qEKeU">
                            <div className="content_contentMainInner__mzO4a">
                                <div className="content_contentDescription__jZM6e markdown">
                                    <p style={{ fontSize: "28px" }}>Bring clarity to your development with
                                        visuals and flow, DevGlu handles the
                                        heavy lifting of code generation with
                                        security and compliance automatically.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <img src={MAIN_PROJECT_2} width={500} />
                    </div>
                    <div className='d-flex gap-3 flex-column'>
                        <img src={MAIN_PROJECT} width={500} />

                        <div className="content_contentMain__qEKeU mt-3">
                            <div className="content_contentMainInner__mzO4a">
                                <div className="content_contentDescription__jZM6e markdown">
                                    <p style={{ fontSize: "28px" }}>Scale your business with DevGlu
                                        capabilities in supporting multi-
                                        environment, multi-cloud and multi-
                                        databases.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            </div>

            <div style={{ marginTop: "150px" }} className="mx-auto max-w-[--page-width] px-2 content_content__zhwUl">
                <div className='d-flex justify-content-between gap-2'>
                    <div className='d-flex gap-3 flex-column mt-4'>

                        <img src={GENERATE_CODE} width={600} />
                    </div>
                    <div className='d-flex gap-1 flex-column'>
                        <p style={{ fontSize: "36px", textAlign: 'center', color: "white" }}>100%</p>
                        <p style={{ fontSize: "24px", textAlign: 'center', color: "white" }}>Code Ownership</p>

                        <div className="content_contentMain__qEKeU mt-3">
                            <div className="content_contentMainInner__mzO4a">
                                <div className="content_contentDescription__jZM6e markdown">
                                    <p style={{ fontSize: "16px", textAlign: 'center' }}>Easily translate your Flow into industry-standard
                                        Code base. DevGlu supports up to 8 development
                                        languages, supporting your every business needs.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="content_contentMain__qEKeU mt-3">
                            <div className="content_contentMainInner__mzO4a">
                                <div className="content_contentDescription__jZM6e markdown">
                                    <p style={{ fontSize: "16px", textAlign: 'center' }}>Export production-ready code in minutes. With
                                        intelligence, DevGlu automatically corrects issues and
                                        run test cases. Accelerating development from months
                                        to days.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className='d-flex justify-content-between align-items-center'>
                            <div className='w-100 text-center'>

                                <img src={INFINITE} width={400} />
                            </div>

                        </div>

                    </div>

                </div>

            </div>


            {/* <div style={{ marginTop: "150px" }} className="mx-auto max-w-[--page-width] px-5 content_content__zhwUl">
                <div className="content_contentMain__qEKeU">
                    <div className="content_contentMainInner__mzO4a">
                        <div className="content_contentDescription__jZM6e markdown">
                            <p>Bring clarity to your development with
                                visuals and flow, DevGlu handles the
                                heavy lifting of code generation with
                                security and compliance automatically.</p>
                        </div>
                        <div className="features_featuresContainer__HUylB">
                            <h4 className="features_featuresHeading__21qLK">Features</h4>
                            <div className="features_accordionRoot__jJnSV" data-orientation="vertical">
                                <Accordion flush open={open} toggle={toggle}>
                                    <AccordionItem>
                                        <AccordionHeader targetId="1">Visual Backend Editor</AccordionHeader>
                                        <AccordionBody accordionId="1">
                                            Use intuitive nodes to build REST APIs, define endpoints, connect database models, and organize middleware flows. The visual canvas makes it easy to map complex backend logic.
                                        </AccordionBody>
                                    </AccordionItem>
                                    <AccordionItem>
                                        <AccordionHeader targetId="2"> Instant Code Generation</AccordionHeader>
                                        <AccordionBody accordionId="2">
                                            After building your flow, generate clean, maintainable backend code using Node.js (Express framework). Download your project as a ZIP and start working on it immediately.
                                        </AccordionBody>
                                    </AccordionItem>
                                    <AccordionItem>
                                        <AccordionHeader targetId="3">Database Modeling</AccordionHeader>
                                        <AccordionBody accordionId="3">
                                            Define your schema visually and choose your database:
                                            MongoDB,
                                            MySQL,
                                            PostgreSQL, etc..
                                            We generate models, relationships, and database connection logic automatically.
                                        </AccordionBody>
                                    </AccordionItem>
                                    <AccordionItem>
                                        <AccordionHeader targetId="4">Custom Code Support</AccordionHeader>
                                        <AccordionBody accordionId="4">
                                            Want to add specific business logic? You can inject custom logic or validators in any node so your app remains flexible.
                                        </AccordionBody>
                                    </AccordionItem>
                                    <AccordionItem>
                                        <AccordionHeader targetId="5">One-Click Download</AccordionHeader>
                                        <AccordionBody accordionId="5">
                                            Generate and download a complete backend project, including:
                                            Route files,
                                            Controllers,
                                            Database connection,
                                            Environment config,
                                            Server setup.
                                        </AccordionBody>
                                    </AccordionItem>
                                </Accordion>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="content_contentSidebar__DSG6D"><div className="template-detail_sidebarSection__rKaMO"><h6 className="text-h6">Categories</h6>
                    <div className="template-detail_categoriesList__jDhJo">
                        <a className="content_contentSidebarTag__t3eeI" >
                            <span>Developers</span>
                        </a>
                        <a className="content_contentSidebarTag__t3eeI" >
                            <span>Founders & Startups</span></a>
                        <a className="content_contentSidebarTag__t3eeI" >
                            <span>Students </span>
                        </a>
                        <a className="content_contentSidebarTag__t3eeI" >
                            <span>Product Teams</span>
                        </a>
                        <a className="content_contentSidebarTag__t3eeI" >
                            <span>Free Trial</span>
                        </a>
                    </div></div>

                    <div className="template-detail_sidebarSection__rKaMO"><h6 className="text-h6">Support</h6>
                        <div className="template-detail_supportLinksList___BnKG">
                            <div className="content_contentSidebarLinkWrapper__7Rf5B">
                                <svg width="20" height="20" fill="currentColor" className="transform-gpu"><use href="/creators/sprite.svg#contact"></use></svg>
                                <a >
                                    <span className="content_contentSidebarLinkText__t1sLF">Contact </span></a>
                            </div>
                            <div className="content_contentSidebarLinkWrapper__7Rf5B">
                                <svg width="20" height="20" fill="currentColor" className="transform-gpu"><use href="/creators/sprite.svg#help"></use></svg>
                                <a >
                                    <span className="content_contentSidebarLinkText__t1sLF">How work</span>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className="content_contentSidebarRefundPolicy__4Dr2s">
                        <h6 className="text-h6">Refund Policy</h6>
                        <p className="content_contentSidebarRefundPolicyText__9ScAH">
                            Framer does not handle refund processing. All products are purchased directly from their respective creators. Please review their refund policy before making any purchase.</p>
                    </div>
                </div>
            </div> */}

            <div className="relative overflow-hidden pt-[120px]">
                <div className="styles_glow1__fihjb">
                </div>
                <div className="styles_glow2__cPJe5">
                    <div className="styles_layer1__p0LCO">
                    </div>
                    <div className="styles_layer2__y_bZo">
                    </div>
                    <div className="styles_layer3__sSp8F">
                    </div>
                </div>
                <div className="mx-auto max-w-[--page-width] px-5 styles_container__xZFFM">
                    <div className="h-full w-full items-center md:flex">
                        <div className="max-w-[450px] flex-grow space-y-[30px] md:min-w-[400px]">
                            <div className="space-y-2.5 text-balance">
                                <h3 className="text-h2">Become a creator today</h3>
                                <p className="text-lead-sm">Submit a template or plugin, get featured, and get paid – all in just a few clicks.</p>
                            </div>
                            <div>
                                <a className="relative rounded-lg bg-white px-3 py-2.5 text-sm font-semibold leading-none text-black transition-opacity duration-500 hover:opacity-80" onClick={() => navigate("/login")}>Open your Dashboard</a>
                            </div>
                        </div>
                        <div className="relative h-[400px] max-w-[1240px] flex-grow pt-20 md:h-[640px] styles_cards__6qMOz">
                            <div className="grid w-[800px] origin-top-left scale-[0.6] grid-cols-3 gap-6 sm:scale-[0.8] md:absolute lg:scale-100">
                                <div className="space-y-8">
                                    <div className="space-y-4 rounded-[16px] p-6 styles_card__GcEhb mb-3">
                                        <div className="relative size-[60px] overflow-hidden rounded-full">
                                            <img alt="Avatar" loading="lazy" decoding="async" data-nimg="fill" sizes="100vw" className="main-img-size" srcset="" src="https://images.unsplash.com/photo-1438761681033-6461ffad8d80?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" />
                                            <div className="absolute inset-0 rounded-full border border-white/10"></div>
                                        </div>
                                        <p className="text-h6 line-clamp-1 text-white">Connelly Rader</p>
                                        <p className="text-color-50 text-body-body">Building Framer Templates in my free time. Framer Expert &amp; Contra Top Independent.</p>
                                        <div className="flex items-center gap-2">
                                        </div>
                                    </div>
                                    <div className="space-y-4 rounded-[16px] p-6 styles_card__GcEhb"><div className="relative size-[60px] overflow-hidden rounded-full">
                                        <img alt="Avatar" loading="lazy" decoding="async" data-nimg="fill" sizes="100vw" className="main-img-size" src="https://images.unsplash.com/photo-1542909168-82c3e7fdca5c?q=80&w=2080&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" />
                                        <div className="absolute inset-0 rounded-full border border-white/10"></div>
                                    </div>
                                        <p className="text-h6 line-clamp-1 text-white">Favorit ×&thinsp;Frame</p>
                                        <p className="text-color-50 text-body-body">Framer Expert Duo Crafting Client Sites and Minimal Templates With a Premium Touch.</p>
                                        <div className="flex items-center gap-2">
                                            <p className="text-label opacity-60">8 Templates</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="space-y-8 md:translate-y-20">
                                    <div className="space-y-4 rounded-[16px] p-6 styles_card__GcEhb mb-3">
                                        <div className="relative size-[60px] overflow-hidden rounded-full">
                                            <img alt="Avatar" loading="lazy" decoding="async" data-nimg="fill" sizes="100vw" className="main-img-size" src="https://images.unsplash.com/photo-1542909168-82c3e7fdca5c?q=80&w=2080&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" />
                                            <div className="absolute inset-0 rounded-full border border-white/10">
                                            </div>
                                        </div>
                                        <p className="text-h6 line-clamp-1 text-white">ena supply</p>
                                        <p className="text-color-50 text-body-body">Building visually striking, and highly functional Framer sites.</p>

                                    </div>
                                    <div className="space-y-4 rounded-[16px] p-6 styles_card__GcEhb ">
                                        <div className="relative size-[60px] overflow-hidden rounded-full">
                                            <img alt="Avatar" loading="lazy" decoding="async" data-nimg="fill" sizes="100vw" className="main-img-size" src="https://images.unsplash.com/photo-1517212160285-e9fbf358c905?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" />
                                            <div className="absolute inset-0 rounded-full border border-white/10"></div>
                                        </div>
                                        <p className="text-h6 line-clamp-1 text-white">LottieFiles</p>
                                        <div className="flex items-center gap-2">
                                        </div>
                                    </div>
                                </div>
                                <div className="space-y-8 md:translate-y-12">
                                    <div className="space-y-4 rounded-[16px] p-6 styles_card__GcEhb mb-3">
                                        <div className="relative size-[60px] overflow-hidden rounded-full">
                                            <img alt="Avatar" loading="lazy" decoding="async" data-nimg="fill" sizes="100vw" className="main-img-size" src="https://images.unsplash.com/photo-1611095973763-414019e72400?q=80&w=2071&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" />
                                            <div className="absolute inset-0 rounded-full border border-white/10">
                                            </div>
                                        </div>
                                        <p className="text-h6 line-clamp-1 text-white">LottieFiles</p>

                                    </div>
                                    <div className="space-y-4 rounded-[16px] p-6 styles_card__GcEhb">
                                        <div className="relative size-[60px] overflow-hidden rounded-full"><img alt="Avatar" loading="lazy" decoding="async" data-nimg="fill" sizes="100vw" className="main-img-size" src="https://images.unsplash.com/photo-1600880292203-757bb62b4baf?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" />
                                            <div className="absolute inset-0 rounded-full border border-white/10"></div>
                                        </div>
                                        <p className="text-h6 line-clamp-1 text-white">Clonify</p>
                                        <p className="text-color-50 text-body-body">An ever-growing design library of stunning sections and templates.</p>
                                        <div className="flex items-center gap-2">
                                            <p className="text-label opacity-60">27s</p>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <footer className="p-5 pb-10 md:justify-center">
                <div className='d-flex justify-content-end align-items-center'>
                    <div className="d-flex gap-4">
                        <div className="text-[13px] leading-none tracking-[-0.15px] text-white">
                            <div className="flex h-[22px] items-center">
                                <h6>Resources</h6>
                            </div>
                        </div>

                        <div className="text-[13px] leading-none tracking-[-0.15px] text-white">
                            <div className="flex h-[22px] items-center">
                                <h6>Creators</h6>
                            </div>
                        </div>

                        <div className="text-[13px] leading-none tracking-[-0.15px] text-white">
                            <div className="flex h-[22px] items-center">
                                <h6>Socials</h6>
                            </div>
                        </div>

                    </div>

                </div>
            </footer>
        </div>

    )
}

export default LandingPage